import PropTypes from 'prop-types';
import React from 'react';
import { i18n } from '../i18n/translate.js';
import { getActiveRuleSetFromUrl } from '../utils/UrlUtil.js';
import { SelectFilter } from './Filters/SelectFilter.js';
import { RuleSetModal } from './RuleSetModal.js';
var ROLE_OPTIONS = Object.freeze([{
  ruleSet: 'he_admin',
  name: 'he_admin',
  label: i18n.t('Higher Education Students'),
  shortLabel: i18n.t('Students')
}, {
  ruleSet: 'fac_staff_admin',
  name: 'fac_staff_admin',
  label: i18n.t('Faculty & Staff'),
  shortLabel: i18n.t('Faculty & Staff')
}, {
  ruleSet: 'cc_admin',
  name: 'cc_admin',
  label: i18n.t('Employees'),
  shortLabel: i18n.t('Employees')
}, {
  ruleSet: 'scorm_manager',
  name: 'scorm_manager',
  label: i18n.t('Scorm'),
  shortLabel: i18n.t('Scorm')
}]);

var getSkipRoleSelectionValue = function getSkipRoleSelectionValue() {
  // Don't check on server render
  if (typeof document !== 'undefined') {
    var _document;

    return !!((_document = document) !== null && _document !== void 0 && _document.querySelector('[data-skip-role-selection="true"]'));
  }

  return false;
};

var SidebarRoleSwitcher = function SidebarRoleSwitcher(_ref) {
  var _ref$currentRuleSets = _ref.currentRuleSets,
      currentRuleSets = _ref$currentRuleSets === void 0 ? [] : _ref$currentRuleSets,
      onMenuClose = _ref.onMenuClose,
      onMenuOpen = _ref.onMenuOpen,
      onSelectRuleSet = _ref.onSelectRuleSet;
  var activeRuleSet = getActiveRuleSetFromUrl(currentRuleSets);
  var availableRuleSets = ROLE_OPTIONS.filter(function (roleOption) {
    return currentRuleSets.some(function (currentRuleSet) {
      return currentRuleSet.name === roleOption.ruleSet;
    });
  });
  var defaultRuleSet = availableRuleSets.find(function (roleOption) {
    return roleOption.ruleSet === (activeRuleSet === null || activeRuleSet === void 0 ? void 0 : activeRuleSet.name);
  });

  var onChange = function onChange(selectedRuleSet) {
    onSelectRuleSet(selectedRuleSet.name);
  };
  /*
    No Role selection if any of the following:
    - Explicit skip from component outside Sidebar scope (a.k.a rendered by RoR). Bug#2830782
    - There is an active rule set but it is not within the TRAIN rulesets (cc_admin, fac_staff_admin, he_admin, scorm_manager).
    - There is not more that one train role to choose from.
  */


  if (getSkipRoleSelectionValue() || activeRuleSet !== null && activeRuleSet !== void 0 && activeRuleSet.name && !defaultRuleSet || availableRuleSets.length < 2) {
    return null;
  } else {
    if (defaultRuleSet) {
      return /*#__PURE__*/React.createElement("div", {
        className: "sidebar-role-switcher",
        "data-object-type": "sidebar-role-switcher",
        "data-action": "sidebar-role-switcher"
      }, /*#__PURE__*/React.createElement(SelectFilter, {
        defaultValue: defaultRuleSet,
        isClearable: false,
        name: "rule_sets",
        onChange: onChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        options: availableRuleSets,
        selectedKey: "shortLabel",
        showSelected: true,
        valueKey: "ruleSet"
      }));
    } else {
      // if no active rule set and more than two available rule sets
      var firstMatchingRuleSet = currentRuleSets.find(function (ruleSet) {
        return availableRuleSets.some(function (availableRuleSet) {
          return availableRuleSet.ruleSet === ruleSet.name;
        });
      });
      var homeHref = firstMatchingRuleSet ? firstMatchingRuleSet.interstitial_redirect : '';
      homeHref = homeHref ? homeHref.slice(0, homeHref.indexOf('?')) : '';
      var ruleSets = availableRuleSets.map(function (currentRuleSet) {
        return currentRuleSet.ruleSet;
      });
      return /*#__PURE__*/React.createElement(RuleSetModal, {
        href: homeHref,
        ruleSets: ruleSets,
        show: true
      });
    }
  }
};

SidebarRoleSwitcher.propTypes = {
  currentRuleSets: PropTypes.arrayOf(PropTypes.shape({
    active: PropTypes.bool,
    interstitial_redirect: PropTypes.string,
    name: PropTypes.string
  })),
  onMenuClose: PropTypes.func,
  onMenuOpen: PropTypes.func,
  onSelectRuleSet: PropTypes.func
};
SidebarRoleSwitcher.displayName = 'SidebarRoleSwitcher';
export { SidebarRoleSwitcher };